<template>
  <span
    :class="[
      'text-xs font-medium text-center inline-flex items-center',
      {
        'text-blue-600': type == 'residential',
        'text-purple-600': type == 'commercial',
        'text-yellow-600': type == 'pre_sale',
        'text-green-600': type == 'property_management',
        'text-indigo-600': type == 'residential_realtor',
        'text-pink-600': type == 'residential_homeowner'
      }
    ]"
  >
    {{
      type == 'residential' ? 'Residential' :
      type == 'commercial' ? 'Commercial' :
      type == 'pre_sale' ? 'Payment on Settlement (pre-sale)' :
      type == 'property_management' ? 'Property Management' :
      type == 'residential_realtor' ? 'Residential Realtor' :
      type == 'residential_homeowner' ? 'Residential Homeowner' : ''
    }}
  </span>
</template>

<script lang="ts" setup>
defineProps({
  type: {
    type: String,
    required: true
  }
})
</script> 